import { render, staticRenderFns } from "./pricePrePortDetail.vue?vue&type=template&id=fb385496&scoped=true&"
import script from "./pricePrePortDetail.vue?vue&type=script&lang=js&"
export * from "./pricePrePortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb385496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb385496')) {
      api.createRecord('fb385496', component.options)
    } else {
      api.reload('fb385496', component.options)
    }
    module.hot.accept("./pricePrePortDetail.vue?vue&type=template&id=fb385496&scoped=true&", function () {
      api.rerender('fb385496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/pricePrePortDetail.vue"
export default component.exports